import { createFileRoute, Navigate } from "@tanstack/react-router";

import Organizations from "../pages/Organizations";
import { useAuth } from "../context/AuthContext";
import { RequireAuth } from "../utils/RequireAuth";

function parseOrganizationsSearch(search: Record<string, unknown>) {
  return {
    tab: search.tab === "chatbots" ? ("chatbots" as const) : ("organizations" as const),
    ...(typeof search.deleted === "string" && search.deleted !== ""
      ? { deleted: search.deleted }
      : {}),
  };
}

export const Route = createFileRoute("/_shell/organizations/")({
  validateSearch: parseOrganizationsSearch,
  component: OrganizationsRoute,
});

function OrganizationsRoute() {
  const auth = useAuth();

  return (
    <RequireAuth>
      {auth.canManageOrganizations === true ? <Organizations /> : <Navigate to="/" replace />}
    </RequireAuth>
  );
}
